import { type LDFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'

export const setFeatureFlags = (value: LDFlags) => ({
  type: SET_FEATURE_FLAGS,
  value,
})
